import { SanitySignupForm } from '../../types/generated/graphql-types'
import { SignupFormBlockProps } from '../components/SignupForm/SignupFormBlock'
import { Breakpoints } from '../utilities/breakpoints'
import { validImage } from '../utilities/imageFilters'
import { Presets } from '../utilities/imagePreset'
import { getImagePropsWithSources } from '../utilities/imagePropUtils'

export const mapSanitySignupFormToSignupFormBlockProps = (
  form: SanitySignupForm
): SignupFormBlockProps => ({
  description: form.description ?? '',
  heading: form.title ?? undefined,
  disclaimer: form._rawDisclaimer,
  image: validImage(form.image)
    ? getImagePropsWithSources(
        form.image,
        {
          small: Presets.subscriptionFormImage.mobile,
          medium: Presets.subscriptionFormImage.extraLarge,
          large: Presets.subscriptionFormImage.xxLarge,
        },
        Breakpoints.sm,
        Breakpoints.xl
      )
    : undefined,
  useNewDesign: form.useNewDesign ?? false,
})
